<template>
  <div class="login_bg_">
    <div class="top_header_">
      <img class="logo_" src="../assets/medilinkPC/logo.png" />
      <label class="com_">
        {{ $t("title") || "中间带(北京)技术服务有限公司" }}</label
      >
      <div class="lang_">
        <a-popover>
          <template slot="content">
            <p>中文</p>
            <p>English</p>
          </template>
          <span @click="changeLanguage">
            {{ $i18n.locale == "zh-cn" ? "中文" : "English" }}
          </span>
        </a-popover>
      </div>
    </div>
    <div class="login_container_">
      <div class="login_left_">
        <span
          v-html="$t('login.lWelcome') || '欢迎登录中间带会员服务系统'"
        ></span>
      </div>
      <div class="login_right_">
        <div class="login_type_">
          <!-- <span @click="changeLoginType">{{ flag  ? '手机号登录' : '账号密码登录'}}
          </span> -->
        </div>
        <div class="type_" v-if="flag">
          <p class="tit_">{{ $t("login.loType") || "账号密码登录" }}</p>
          <a-form
            id="components-form-demo-normal-login"
            :form="form"
            class="login_form_"
            @submit="accountSubmit"
          >
            <a-form-item style="margin-bottom: 14px;">
              <a-input
                style="background: #f6f6f6;height:46px;border-radius:8px;"
                v-decorator="[
                  'cardNo',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('login.yhm') || '请输入8000开头的保险卡号'
                      }
                    ]
                  }
                ]"
                :placeholder="$t('login.yhm') || '请输入8000开头的保险卡号'"
                size="large"
              >
                <img
                  class="img_"
                  slot="prefix"
                  src="../assets/medilinkPC/cardno.png"
                  alt=""
                />
              </a-input>
            </a-form-item>
            <a-form-item style="margin-bottom: 14px;">
              <a-input
                v-decorator="[
                  'password',
                  {
                    rules: [
                      {
                        required: true,
                        message:
                          $t('login.mm') || '请输入密码（默认身份证后六位）'
                      }
                    ]
                  }
                ]"
                type="password"
                :placeholder="
                  $t('login.mm') || '请输入密码（默认身份证后六位）'
                "
                size="large"
                style="height:46px;border-radius:8px;"
              >
                <img
                  class="img_"
                  slot="prefix"
                  src="../assets/medilinkPC/pwd.png"
                  alt=""
                />
                <!-- <a-icon
                    slot="suffix"
                    type="lock"
                    style="color: rgba(0,0,0,.25)"
                  /> -->
              </a-input>
            </a-form-item>
            <a-form-item style="margin-bottom: 14px;">
              <a-input
                v-decorator="[
                  'verificationCode',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('login.yzm') || '请输入验证码'
                      }
                    ]
                  }
                ]"
                :placeholder="$t('login.yzm') || '请输入验证码'"
                size="large"
                class="grey"
                style="height:46px;border-radius:8px;"
              >
                <img
                  class="img_"
                  slot="prefix"
                  src="../assets/medilinkPC/veri.png"
                  alt=""
                />
                <!-- <a-icon slot="suffix" type="lock" style="color: rgba(0,0,0,.25)" /> -->
              </a-input>
              <img
                class="veri_code_"
                @click="changeImgCodeUri"
                :src="imgCodeUri"
              />
            </a-form-item>
            <!-- <div :class="`error_ ${hasError ? 'show_' : 'hide_'}`">
                {{ errorMsg }}
              </div> -->
            <div class="forget_">
              <a-checkbox @change="rememberPwd">
                {{ $t("login.remember") || "记住登录" }}
              </a-checkbox>
              <span class="forget_pwd" @click="forgetPwd">{{
                $t("login.forgot") || "忘记密码?"
              }}</span>
            </div>
            <a-form-item>
              <a-button
                size="large"
                type="primary"
                html-type="submit"
                class="login-form-button"
                style="height:46px;border-radius:8px;font-size:14px;"
              >
                {{ $t("login.dl") || "登录" }}
              </a-button>
            </a-form-item>
          </a-form>
          <div class="agree">
            <a-checkbox v-model="checked" @change="onChange">
              我已阅读并同意使用
              <a class="color" @click.stop="go">《中间带隐私政策》</a>
            </a-checkbox>
          </div>
        </div>
        <!-- 以下功能已去除 -->
        <div class="type_" v-else>
          <p class="tit_">手机号登录</p>
          <a-form
            id="components-form-demo-normal-login"
            :form="mobileForm"
            class="login_form_"
            @submit="mobileSubmit"
          >
            <a-form-item>
              <a-input
                v-decorator="[
                  'mobile',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('login.yhm') || '请输入手机号码!'
                      }
                    ]
                  }
                ]"
                :placeholder="$t('login.yhm') || '请输入手机号码'"
                size="large"
              >
                <img
                  class="img_"
                  slot="prefix"
                  src="../assets/medilinkPC/mobile.png"
                  alt=""
                />
              </a-input>
            </a-form-item>
            <a-form-item style="margin-bottom: 0;">
              <a-input
                v-decorator="[
                  'veriCode',
                  {
                    rules: [
                      {
                        required: true,
                        message: $t('login.yzm') || '请输入验证码'
                      }
                    ]
                  }
                ]"
                :placeholder="$t('login.yzm') || '请输入验证码'"
                size="large"
              >
                <img
                  class="img_"
                  slot="prefix"
                  src="../assets/medilinkPC/veri.png"
                  alt=""
                />
                <span slot="suffix" style="color: #2C5ACC;">发送验证码</span>
                <!-- <a-icon slot="suffix" type="lock" style="color: rgba(0,0,0,.25)" /> -->
              </a-input>
              <!-- <img
                  class="veri_code_"
                  @click="changeImgCodeUri"
                  :src="imgCodeUri"
                /> -->
            </a-form-item>
            <div :class="`error_ ${hasError ? 'show_' : 'hide_'}`">
              <!-- {{ errorMsg }} -->
            </div>
            <a-form-item>
              <a-button
                size="large"
                type="primary"
                html-type="submit"
                class="login-form-button"
              >
                {{ $t("login.dl") || "登录" }}
              </a-button>
            </a-form-item>
          </a-form>
        </div>
        <div class="bottom_logo_">
          <img src="../assets/medilinkPC/logo.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/utils/api";
import { setLogined, setLang } from "@/utils/authorized";
import encrypt from '@/utils/crypt'
import moment from "moment";

export default {
  data() {
    return {
      checked: false, // 是否勾选了协议
      errorMsg: "",
      hasError: false,
      mobileForm: this.$form.createForm(this),
      activeTab: 0,
      imgCodeUri: "/api/web/sendCode",
      submitDisabled: false,

      loginType: "account", // account 账号  mobile 手机号
      flag: true
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    api
      .getLanguageL()
      .then(res => res.data)
      .then(data => {
        console.log(data.data.language, "data.data.language");
        this.saveLang(data.data.language);
      });
  },
  created() {
    this.changeImgCodeUri();
  },
  methods: {
    go() {
      this.checked = true;
      let routerData = this.$router.resolve({
        name: "privacyAgreement"
      });
      window.open(routerData.href, "_blank"); //打开新标签
    },
    forgetPwd() {
      let _cardNo = this.form.getFieldValue('cardNo') || '';
      this.$router.push({
        name: "ForgetPwd",
        query: { cardNo: _cardNo }
      });
    },
    rememberPwd(e) {
      console.log(`checked = ${e.target.checked}`);
    },
    onChange(e) {
      this.checked = e.target.checked;
    },
    changeLoginType() {
      if (this.loginType == "account") {
        this.flag = false;
        this.loginType = "mobile";
      } else {
        this.flag = true;
        this.loginType = "account";
      }
    },

    saveLang(langNum) {
      const lang = langNum == "01" ? "zh-cn" : "en-us";
      setLang(lang);
      moment.locale(lang);
      this.$i18n.locale = lang;
    },
    changeLanguage() {
      let lang = "zh-cn";
      let langNum = "01";
      if (this.$i18n.locale == "en-us") {
        this.$i18n.locale = "zh-cn";
      } else {
        this.$i18n.locale = "en-us";
        lang = "en-us";
        langNum = "02";
      }
      setLang(lang);
      moment.locale(lang);
      api
        .changLanguageL({
          language: langNum
        })
        .then(res => res.data);
    },
    handleChangePwdSubmit(e) {
      e && e.preventDefault();
      this.submitDisabled = true;
      let st = setTimeout(() => {
        clearTimeout(st);
        this.submitDisabled = false;
      }, 60 * 1000);
      this.pwdForm.validateFields((error, values) => {
        if (!error) {
          console.log("handleChangePwdSubmit -> ", values);
          api
            .sendEmail({
              ...values
            })
            .then(res => res.data)
            .then(data => {
              this.hasError = false;
              this.$message.success(
                this.$t("tips[41]") || "已发送邮件 60秒后可再次发送"
              );
            })
            .catch(err => {
              this.errorMsg = err.data.msg || "";
              this.hasError = true;
              this.submitDisabled = false;
              clearTimeout(st);
            });
        }
      });
    },
    switchTab(val) {
      this.activeTab = val;
      this.hasError = false;
    },
    changeImgCodeUri() {
      this.imgCodeUri = "/api/web/sendCode?rand=" + Math.random();
    },
    accountSubmit(e) {
      e.preventDefault();
      if (!this.checked) {
        // 未勾选协议
        this.$message.error("请先阅读《中间带隐私政策》");
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          api
            .goLoginInfo({
              ...values,
              password: encrypt(values.password)
            })
            .then(res => res.data)
            .then(data => {
              setLogined(1);
              localStorage.setItem("account", values.cardNo);
              console.log(data, "data===>");
              if (data.code == 200) {
                if (data.data.passWordFlag == "1") {
                  this.$router.push({
                    path: "/Home/UpdatePwd"
                  });
                } else {
                  this.$router.push({
                    path: "/Home/Index",
                    query: { account: values.cardNo }
                  });
                }
              }
            })
            .catch(error => {
              this.changeImgCodeUri();
            });
        }
      });
    },
    mobileSubmit(e) {
      e.preventDefault();
      this.mobileForm.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          this.$router.push("/Home/Index");
        }
      });
    }
  }
};
</script>
<style lang="scss">
.error_ {
  color: red;
  line-height: 24px;
  height: 24px;
  &.hide_ {
    visibility: hidden;
  }
  &.show_ {
    visibility: show;
  }
}
.login_bg_ {
  height: 100%;
  overflow: hidden;
  background: url("../assets/medilinkPC/home_bg.jpg") no-repeat;
  background-size: 100% 100%;
  background-position: top left;
  .agree {
    margin-top: -20px;
    .color {
      cursor: pointer;
      color: #2c5acc;
    }
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #2c5acc;
    border-color: #2c5acc;
  }
  .top_header_ {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: rgba(255, 255, 255, 0.8);
    padding: 12px 44px 0 43px;
    height: 60px;
    // margin-bottom: 60px;
    .com_ {
      color: #333333;
      font-size: 15px;
      margin-left: 42px;
    }

    .logo_ {
      width: 102px;
      height: auto;
    }
    .lang_ {
      float: right;
      margin-right: 24px;
      cursor: pointer;
      position: relative;
      ::before {
        content: "";
        position: absolute;
        top: 8px;
        left: 120%;
        border: 4px solid;
        border-color: #394155 transparent transparent transparent;
      }
    }
  }
  display: flex;
  justify-content: center;
  align-items: center;

  .left_wrap_ {
    display: inline-block;
    vertical-align: middle;
    color: #fff;
    width: 373px;
    margin-right: 143px;
    .list_ {
      li {
        &::before {
          content: "";
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 8px;
          background: #fff;
          vertical-align: middle;
        }
      }
    }
    .line_ {
      width: 36px;
      height: 3px;
      background: rgba(255, 255, 255, 1);
    }
    .title_ {
      font-size: 26px;
      margin: 28px 0;
    }
    .copyright_ {
      margin: 29px 0 19px;
    }
    .fs9_ {
      font-size: 9px;
    }
  }
}
.login_container_ {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  width: 740px;
  height: 480px;
  box-sizing: border-box;
  background: url("../assets/medilinkPC/login_container.png");
  background-size: 100% 100%;
  * {
    box-sizing: border-box;
  }
  .login_left_ {
    position: absolute;
    top: 50%;
    left: 85px;
    width: 15px;
    color: #fff;
    line-height: 22px;
    font-size: 18px;
    transform: translateY(-50%);
    text-align: center;
  }
  .login_right_ {
    position: absolute;
    width: 500px;
    height: 100%;
    right: 0;
    top: 0;
    .login_type_ {
      text-align: right;
      margin-right: 30px;
      margin-top: 30px;
      font-size: 14px;
      color: #2c5acc;
    }
    .type_ {
      width: 300px;
      transform: translate(25%, 10%);
      .tit_ {
        font-weight: 600;
        font-size: 18px;
        color: #394155;
        text-align: center;
      }
      .img_ {
        width: 16px;
        height: 16px;
      }
      .ant-input {
        padding-left: 35px;
      }
      .forget_ {
        margin-top: 15px;
        margin-bottom: 15px;
        display: flex;
        justify-content: space-between;
        .forget_pwd {
          cursor: pointer;
          color: #2c5acc !important;
        }
      }
    }
    .mobile_type_ {
      transform: translateY(25%);
    }
    .bottom_logo_ {
      position: absolute;
      left: 35%;
      width: 101px;
      height: 32px;
      img {
        margin-top: 40px;
        width: 100%;
        height: 100%;
      }
    }
  }
  .login_title_ {
    margin-bottom: 29px;
    height: 27px;
    cursor: pointer;

    li {
      display: inline-block;
      color: #999999;
      font-size: 12px;
      transition: all 0.3s ease-in;
      margin-right: 29px;
      &.active_ {
        font-size: 18px;
        color: #333333;
        font-weight: 600;
      }
    }
  }
  .veri_code_ {
    width: 70px;
    height: 31px;
    background: rgba(239, 242, 255, 1);
    position: absolute;
    top: 50%;
    z-index: 2;
    transform: translateY(-50%);
    line-height: 0;
    right: 12px;
  }
  .steps_wrap_ {
    font-size: 9px;
    color: #666666;
    text-align: center;
    margin: 26px 0 42px;

    li {
      display: inline-block;
      vertical-align: middle;
    }
    .desc_01_ {
      width: 96px;
    }
    .desc_02_ {
      width: 66px;
    }
    .step_ {
      display: block;
      width: 16px;
      height: 16px;
      margin: 0 auto;
      border-radius: 50%;
      line-height: 16px;
      background: #23e2b7;
      color: #fff;
      text-align: center;
      margin-bottom: 7px;
    }
    .arrow_ {
      display: inline-block;
      vertical-align: middle;
      width: 40px;
      height: 21px;
      background: url("../assets/arrow.png") no-repeat;
      background-size: 100% auto;
      margin: 0 28px 0 23px;
    }
  }
}
.login_form_ .login-form-button {
  width: 100%;
  margin: 0 auto;
  background: linear-gradient(90deg, rgba(35, 226, 183, 1) 100%);
  border-radius: 8px;
  border: none;
  &:hover {
    background: linear-gradient(90deg, rgba(35, 226, 183, 0.6) 100%);
  }
  &:focus {
    background: linear-gradient(90deg, rgba(35, 226, 183, 1) 100%);
  }
}

.login_form_ {
  .ant-form-item {
    .ant-form-item-control-wrapper {
      .ant-form-item-control {
        .ant-form-item-children {
          .ant-input-affix-wrapper {
            .ant-input {
              background: #f6f6f6;
              border-radius: 8px;
              border: none;
              &::placeholder {
                font-size: 14px;
              }
            }
          }
          .login-form-button {
            background: #2c5acc;
            &:hover {
              background: #1548ca;
            }
          }
        }
      }
    }
  }
}
</style>
